<template>
  <div>
    <PmwParagraph
      size="paragraph-80"
      weight="light"
      class="absolute-calendar--title"
    >
      Preço base
    </PmwParagraph>

    <AbsoluteCalendarInput
      v-for="item in allItems"
      v-model="item.valoresOcupantes"
      :key="item.codigo"
      :roomData="{ name: item.nome, codigo: item.codigo }"
      :adults="item.maximoAdultos"
      :children="item.maximoCriancas"
      @inputEvent="inputEvent"
      @hasAllFields="hasAllFields($event)"
    />
  </div>
</template>

<script>
import AbsoluteCalendarInput from '@/components/hotel/masterRates/pricing/AbsoluteCalendarInput'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'

export default {
  name: 'AbsoluteCalendar',

  components: {
    AbsoluteCalendarInput,
    PmwParagraph
  },

  props: {
    value: {
      type: Array,
      default: () => []
    },

    allRooms: {
      type: Array,
      default: () => []
    },

    selectedRooms: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      allItems: []
    }
  },

  watch: {
    selectedRooms: {
      handler(newValue) {
        if (newValue.length) {
          this.allItems = []
          newValue.forEach((item) => {
            this.allRooms.forEach((el) => {
              if (el.codigo === item) {
                this.allItems.push({ ...el, valoresOcupantes: [] })
              }
            })
          })
        } else {
          this.allItems = this.allRooms.map((item) => {
            return {
              ...item,
              valoresOcupantes: []
            }
          })
        }
      },
      immediate: true
    },

    value: {
      handler(newVal) {
        if (newVal.length) {
          newVal.forEach((element) => {
            const idx = this.allItems.findIndex(
              (item) => item.codigo === element.codigoQuarto
            )

            if (idx > -1) {
              this.allItems[idx].valoresOcupantes = element.valoresOcupantes
            }
          })
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    /**
     * Passa os valores dos quartos para o value
     * @param {array} values: valores dos inputs
     * @param {number} id: ID do quarto
     */
    inputEvent(values, id) {
      let idx = -1

      /** Verifica se o quarto já tem algum valor inserido */
      idx = this.value.findIndex((item) => item.codigoQuarto === id)

      /** Se sim, atualiza os valores */
      if (idx > -1) {
        this.value[idx].valoresOcupantes = []
        this.value[idx].valoresOcupantes = values
      } else {
        /** Se não, insere os valores no value */
        this.value.push({
          codigoQuarto: id,
          valoresOcupantes: values
        })
      }
    },

    /**
     * Emite o evento com os campos preenchidos
     * @param {boolean} event: se todos os campos do quarto estão preenchidos
     */
    hasAllFields(event) {
      this.$emit('hasAllFields', event)
    }
  }
}
</script>

<style lang="scss" scoped>
.absolute-calendar {
  &--title {
    margin: 25px 0 35px;
  }
}
</style>
